// extracted by mini-css-extract-plugin
export default {"dates":"ProgressProject_dates__5nwNp","dates_label":"ProgressProject_dates_label__i0Kow"};